import { INavigation } from '../models/INavigation';

const UserHeading = {
    text: 'User navigation',
    heading: true
};

const UserProfile = {
    text: 'Profile',
    link: '/user/profile',
    icon: 'icon-home',
};

const UserVacation = {
    text: 'Vacations / Day Off',
    link: '/user/vacations',
    icon: 'icon-cup',
};

const UserFinanceReport = {
    text: 'Rates / Salary',
    link: '/user/finance-report',
    icon: 'icon-chart'
};

const UserReport = {
    text: 'Report',
    link: '/user/report',
    icon: 'icon-clock'
};

const UserCoworkers = {
    text: 'Co-workers',
    link: '/user/co-workers',
    icon: 'icon-people'
};

const UserTokens = {
  text: 'Tokens',
  link: '/user/tokens',
  icon: 'icon-link'
};

const AdminHeading = {
    text: 'Admin navigation',
    heading: true,
    roles: ['admin', 'salesadmin', 'projectadmin']
};

const Home = {
    text: 'Home',
    link: '/admin/home',
    icon: 'icon-home',
    roles: ['admin', 'salesadmin', 'projectadmin']
};

const Users = {
    text: 'Users',
    link: '/admin/employee',
    icon: 'icon-people',
    roles: ['admin', 'salesadmin', 'projectadmin']
};

const Salary = {
    text: 'Salary',
    link: '/admin/salary',
    icon: 'icon-wallet',
    roles: ['admin']
};

const Vacations = {
    text: 'Vacations',
    link: '/admin/vacations',
    icon: 'icon-cup',
    roles: ['admin', 'salesadmin', 'projectadmin']
};

const Reports = {
    text: 'Reports',
    link: '/admin/reports',
    icon: 'icon-clock',
    roles: ['admin', 'salesadmin', 'projectadmin']
};

const Customers = {
    text: 'Customers',
    link: '/admin/customers',
    icon: 'icon-briefcase',
    roles: ['admin', 'salesadmin', 'projectadmin']
};

const Invoices = {
    text: 'Invoices',
    link: '/admin/invoices',
    icon: 'icon-basket',
    roles: ['admin', 'salesadmin']
};

const FinanceReport = {
    text: 'Money balance',
    link: '/admin/finance-report',
    icon: 'icon-chart',
    roles: ['admin']
};

const Summaries = {
    text: 'Finance report',
    link: '/admin/summaries',
    icon: 'icon-chart',
    roles: ['admin']
};

export const menu: INavigation[] = [
    UserHeading,
    UserProfile,
    UserVacation,
    UserFinanceReport,
    UserReport,
    UserTokens,
    UserCoworkers,
    AdminHeading,
    Home,
    Users,
    Vacations,
    Reports,
    Salary,
    Customers,
    Invoices,
    FinanceReport,
    Summaries
];
